const pagesStyle = theme => ({
  wrapper: {
    height: "auto",
    minHeight: "100vh",
    position: "relative",
    top: "0"
  },
  fullPage: {
    padding: "0px",
    position: "relative",
    minHeight: "100vh",
    display: "flex!important",
    margin: "0",
    border: "0",
    //color: whiteColor,
    alignItems: "center",
    backgroundSize: "cover",
    //backgroundPosition: "center center",
    //background:'red',
    backgroundColor:'linear-gradient(0deg, #562682, #408199)',
    height: "100%",
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
      border: "none !important"
    }
  }
});

export default pagesStyle;
